import Prismic from 'prismic-javascript'

const REPOSITORY = "playitas"
export const API_URL = `https://${REPOSITORY}.cdn.prismic.io/api/v2`

const API_TOKEN = "MC5ZWkprM0JFQUFDQUFMcVl1.QmpkJO-_vXbvv73vv73vv70Z77-9XQbvv73vv70U77-977-9Hgbvv73vv73vv73vv73vv70B77-9Vu-_ve-_vSHvv70"

export const client = Prismic.client(API_URL, { accessToken: API_TOKEN })